import { render, staticRenderFns } from "./BestellungRowLieferung.vue?vue&type=template&id=fd1a14be"
import script from "./BestellungRowLieferung.vue?vue&type=script&lang=ts"
export * from "./BestellungRowLieferung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports